import React, {useState, useEffect} from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { BsShopWindow } from "react-icons/bs";
import QRCode from "react-qr-code";
import { useStateContext } from '../contexts/ContextProvider';
import {getClientes} from "../services/Clientes";
import { fetchUser } from '../utils/fetchUser';

const Chat = () => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const userInfo = fetchUser();
  const [idSucursal, setIdSucursal] = useState(userInfo.sucursal);
  const [sucursalesData, setSucursalesData] = useState([]);
  const [miUserInfo,setMiUserInfo] = useState();

  useEffect(()=>{
    const fetchData = async () => {
      const misSucursales = await getClientes();

     // console.log(' DATOS ' + JSON.stringify(misSucursales));

      setSucursalesData(misSucursales);
    };
    fetchData();
  },[]);


  const handleChange = (e) =>{
    setIdSucursal( e.target.value );
   // console.log(' SELECCIONE ' +  e.target.value );
    const sucursalSeleccionada = sucursalesData.find((item) => item._id === e.target.value);

    console.log('ENCONTRE ' + JSON.stringify(sucursalSeleccionada));
    // 1. Obtener los datos actuales de la localStorage
    const localStorageData = JSON.parse(localStorage.getItem('profile'));

    // 2. Realizar las actualizaciones necesarias
    if (localStorageData && sucursalSeleccionada) {
      // Realiza la actualización solo si los datos existen en la localStorage
      localStorageData.sucursal = sucursalSeleccionada._id;
      localStorageData.sucursalNombre = sucursalSeleccionada.nombre;
      localStorageData.direccion = sucursalSeleccionada.direccion;
      localStorageData.telefono = sucursalSeleccionada.telefono;
    }

    // 3. Guardar los datos actualizados en la localStorage
    localStorage.setItem('profile', JSON.stringify(localStorageData));
    setIsClicked( !isClicked.Chat );

  };

  return (
    <div className="nav-item absolute right-5 md:right-52 top-16 bg-white dark:bg-[#42464D] p-8 rounded-lg w-96">
      <div className="flex justify-between items-center">
        <div className="flex gap-3">
          <p className="font-semibold text-lg dark:text-gray-200">Sucursal</p>
          <button type="button" className="text-white  text-xs rounded p-1 px-2 bg-orange">
            Sucursal/Caja
          </button>
        </div>
        <button
            type="button"
            onClick={ () => { setIsClicked( !isClicked.Chat )} }
            style={{ color: 'rgb(153, 171, 180)', borderRadius: '50%' }}
            className="text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray"
          >
            <MdOutlineCancel />
          </button>
      </div>
      <div className="mt-5 ">
      <div>
          <div className="flex gap-5 border-b-1 border-color p-4 hover:bg-light-gray cursor-pointer  dark:hover:bg-[#42464D]">
            <button
              type="button"
              style={{ color: '#03C9D7', backgroundColor: '#E5FAFB'}}
              className=" text-xl rounded-lg p-3 hover:bg-light-gray"
            >
               <BsShopWindow />
            </button>

            <div>
           
              
                <div>
                <p className="font-semibold dark:text-gray-200 ">Cambiar Sucursal</p>
                </div>
                <div >
                    <select className="text-xs border-gray-200 outline-none border-2 p-2  focus:border-gray-300" name="idSucursal" value= {idSucursal} required onChange={handleChange}>   
                      {sucursalesData?.map((item, index) => (
                        <option value={item._id}>{item.nombre}</option>
                      ))}    
                    </select>
                </div>    

            </div>
          </div>

          </div>

      </div>
    </div>
  );
};

export default Chat;
